import { getAssetURL } from "helpers/assets";

const TARALITE_ILL_GCS_PATH = "taralite-com/assets/images/illustrations";

const handIll = getAssetURL(`${TARALITE_ILL_GCS_PATH}/hand-illustration.svg`);
const newHandIll = getAssetURL(`${TARALITE_ILL_GCS_PATH}/new-hand-illustration.svg`);
const borrowerLandingIll = getAssetURL(`${TARALITE_ILL_GCS_PATH}/borrower-landing.svg`);
const underlyingLandingIll = getAssetURL(`${TARALITE_ILL_GCS_PATH}/underlying-landing.svg`);

export { handIll, newHandIll, borrowerLandingIll, underlyingLandingIll };
